module.exports = __webpack_public_path__ + "static/skypegrid.46350206.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/crossfader/skypegrid.jpg
// module id = 478
// module chunks = 261706647590803